import { render, staticRenderFns } from "./backOut.vue?vue&type=template&id=67c42a65"
import script from "./backOut.vue?vue&type=script&lang=js"
export * from "./backOut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports